export const optimisticResponse = ({
  projectUri,
  projectTeamMemberAssignmentType
}) => ({
  __typename: 'Mutation',
  updateProject2: {
    __typename: 'Project',
    id: projectUri,
    projectTeamMemberAssignmentType
  }
});
